import React, {useEffect, useState} from 'react';
import * as CandidateService from "@app/services/CandidateService";
import {ResponseCode} from "@app/constants/Common";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {alertMessage} from "@app/constants/Messages";
import {optionsToString} from "@app/utils/CommonUtils";
import Select from "react-select";
import CandidateDVTJCUVInputNewTimesModal from "@pages/candidate/detail/CandidateDVTJCUVInputNewTimesModal";
import CandidateDVTJCUVExtendExpiryTimeModal from "@pages/candidate/detail/CandidateDVTJCUVExtendExpiryTimeModal";
import {convertVNDateTimeToYYYYMMDD} from "@app/utils/DateTimeUtils";
import {
    JobFindModeOptions
} from '@pages/dvtjcuv/common/Constant';
import { set } from 'lodash';

export const ServiceStatuses = {
    // BLANK: '',
    ACTIVE: {id: 1, title: 'Active'},
    PAUSE: {id: 2, title: 'Tạm dừng'},
    // NEED_TO_FIND_MORE_EMP: {id: 3, title: 'Need to find more Emp'},
    RE_ACTIVE: {id: 4, title: 'Re-Active'},
    EXPIRED: {id: 5, title: 'Hết hạn'},
}

const ServiceStatusOptions = Object.values(ServiceStatuses).map((item, index) => {
    return {value: item.id, label: item.title}
})

const DVTJCUVUseStatusFields = [
    {
        key: 'service_status',
        label: 'Trạng thái SD DV',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        editable: true,
        searchable: true,
        options: ServiceStatusOptions
    },
    // {
    //     key: 'dvtjcuv_find_job_mode',
    //     label: 'Chế độ tìm job (DVTJCUV)',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'option',
    //     editable: true,
    //     isMulti: false,
    //     options: JobFindModeOptions,
    // },
    {
        key: 'first_active_date_time',
        label: 'Activate Time',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'service_use_month',
        label: 'Thời hạn sử dụng DV (Months)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        searchable: false
    },
    {
        key: 'expiry_date_time',
        label: 'Expired Time',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        searchable: false
    },
    {
        key: 'note',
        label: 'Note',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        capitalize: true,
        searchable: false
    },
    // {key: 'agreement', label: 'Agreement', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: false},

    // {key: 'service_status_history', label: 'History Trạng thái SD DV', classNames: '', displayType: 'text', inputType: 'number', editable: true, searchable: true},
    // {key: 'invoice_name', label: 'Tên Người được xuất hóa đơn', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: true},
    // {key: 'address', label: 'Địa chỉ', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: false},
    // {key: 'tax_code', label: 'Mã số thuế', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: false},
];

const DVTJCUVClientFields = [
    // {key: 'service_status', label: 'Trạng thái SD DV', classNames: '', displayType: 'text', inputType: 'option', editable: true, searchable: true, options: ServiceStatusOptions},
    // {key: 'service_status_history', label: 'History Trạng thái SD DV', classNames: '', displayType: 'text', inputType: 'number', editable: true, searchable: true},
    {
        key: 'service_use_times',
        label: 'Lần SD DV',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'first_active_date_time',
        label: 'Activate Time',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'service_use_month',
        label: 'Thời hạn sử dụng DV (Months)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        capitalize: true,
        searchable: false
    },
    {
        key: 'expiry_date_time',
        label: 'Expired Time',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        capitalize: true,
        searchable: false
    },
    {
        key: 'sum_paused_days',
        label: 'Tổng số ngày Tạm dừng',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        capitalize: true,
        searchable: false
    },
    {
        key: 'sum_used_days',
        label: 'Tổng số ngày SDDV',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        capitalize: true,
        searchable: false
    },
    {
        key: 'note',
        label: 'Note',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        capitalize: true,
        searchable: false
    },
];

const CandidateDVTJCUV = (props) => {
    const [originUseTimes, setOriginUseTimes] = useState({});
    const [currentUseTimes, setCurrentUseTimes] = useState({});
    const [useTimesList, setUseTimesList] = useState([]);
    const [firstClient, setFirstClient] = useState({id: ''});
    const [serviceStatusHistories, setServiceStatusHistories] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    // const [canEditActiveTime, setCanEditActiveTime] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showInputNewTimesModal, setShowInputNewTimesModal] = useState(false);
    const [showInputNewExpiryTimesModal, setShowInputNewExpiryTimesModal] = useState(false);
    const [statusOptions, setStatusOptions] = useState([...ServiceStatusOptions]);

    const {candidateId, mode, onChange} = props

    const getSelectedStatusOption = (value) => {
        return ServiceStatusOptions.filter(
            item => item.value === value
        )[0] || {label: '', value: ''}
    }

    const createStatusOptions = (orTime) => {
        if (orTime.service_status) {
            const statusValue = orTime.service_status;
            if (statusValue === ServiceStatuses.ACTIVE.id) {
                setStatusOptions(
                    [...ServiceStatusOptions.filter(
                        item => {
                            return item.value !== ServiceStatuses.RE_ACTIVE.id
                                && item.value !== ServiceStatuses.EXPIRED.id
                        }
                    )]
                )
            } else if (statusValue === ServiceStatuses.PAUSE.id) {
                setStatusOptions(
                    [...ServiceStatusOptions.filter(
                        item => {
                            return item.value === ServiceStatuses.RE_ACTIVE.id
                            // || item.value ===ServiceStatuses.EXPIRED.id
                        })]
                )
            } 
            // else if (statusValue === ServiceStatuses.NEED_TO_FIND_MORE_EMP.id) {
            //     setStatusOptions(
            //         [...ServiceStatusOptions.filter(
            //             item => {
            //                 return item.value === ServiceStatuses.PAUSE.id
            //                 // || item.value ===ServiceStatuses.EXPIRED.id
            //             })]
            //     )
            // } 
            else if (statusValue === ServiceStatuses.RE_ACTIVE.id) {
                setStatusOptions(
                    [...ServiceStatusOptions.filter(
                        item => {
                            return item.value !== ServiceStatuses.ACTIVE.id
                                && item.value !== ServiceStatuses.EXPIRED.id
                        }
                    )]
                )
            } else if (statusValue === ServiceStatuses.EXPIRED.id) {
                setStatusOptions([])
            }
        }
    }

    const fetchCandidateDVTJCUV = async (canId) => {
        setIsLoading(true)
        const res = await CandidateService.requestGetCandidateDVTJCUV(canId)
        setIsLoading(false)
        if (res.sts_code === ResponseCode.SUCCESS) {
            const useTimes = res.content.clients
            setUseTimesList(useTimes)
            if (useTimes.length > 0) {
                setFirstClient(useTimes[useTimes.length - 1])
            }
            if (useTimes.length > 0) {
                const currUseTimes = {...useTimes[0]}
                createStatusOptions(currUseTimes)
                setOriginUseTimes({...currUseTimes})
                currUseTimes.service_status = getSelectedStatusOption(currUseTimes.service_status)

                // Bỏ đi vì phát sinh lỗi bị giảm mất 1 ngày nếu convert bằng cách dùng toISOString
                // currUseTimes.expiry_date_time = convertVNDateTimeToDate(currUseTimes.expiry_date_time)
                // currUseTimes.expiry_date_time = currUseTimes.expiry_date_time.toLocaleDateString().slice(0, 10)
                currUseTimes.expiry_date_time = currUseTimes.expiry_date_time.slice(0, 10)
                // currUseTimes.first_active_date_time = currUseTimes.first_active_date_time.slice(0, 10)
                // const [datePart] = convertVNDateTimeToDate(currUseTimes.first_active_date_time).toISOString().split('T');
                // Chuyển đổi first_active_date_time sang định dạng yyyy-MM-dd để hiển thị đúng trong input type="date"
                currUseTimes.first_active_date_time = convertVNDateTimeToYYYYMMDD(currUseTimes.first_active_date_time);
                currUseTimes.origin_first_active_date_time = currUseTimes.first_active_date_time;
                setCurrentUseTimes(currUseTimes)
            }

            const histories = res.content.service_status_histories
            setServiceStatusHistories(histories)
            // setCanEditActiveTime(res.content.can_edit_active_time)
        }
    };

    const updateCandidateDVTJCUV = async () => {
        // Validate input active date time
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const inputDate = new Date(currentUseTimes.first_active_date_time);
        inputDate.setHours(0, 0, 0, 0);
        if (inputDate < today && currentUseTimes.service_status
             && (currentUseTimes.service_status.value === ServiceStatuses.ACTIVE.id
                 || currentUseTimes.service_status.value === ServiceStatuses.RE_ACTIVE.id)) {
            const confirmResult = window.confirm("Bạn đang nhập back date cho Activate Time. Bạn có chắc chắn không?");
            if (!confirmResult) {
                return;
            }
        }


        const body = {...currentUseTimes}
        body.candidate_id = candidateId;
        body.service_status = optionsToString(body.service_status, false)
        body.paused_times = currentUseTimes.paused_times
        if (currentUseTimes.paused_times >= 2 && body.service_status === ServiceStatuses.PAUSE.id) {
            if (window.confirm("Lần SD DV hiện tại của Person này, đã có >=2 lần tạm dừng DV." +
                " Bạn có cho phép Cdd tiếp tục tạm dừng không?") !== true) {
                return;
            }
        }

        setIsLoading(true)
        const res = await CandidateService.requestUpdateCandidateDVTJCUV(body)
        setIsLoading(false)
        if (res.sts_code === ResponseCode.SUCCESS) {
            showSuccessMessageSaveData(res.sts_code)
            setIsEdit(false)
            await fetchCandidateDVTJCUV(candidateId)
        } else {
            alertMessage(res.sts_code, true, true)
        }
    };

    const onCreateNewUseTimes = () => {
        setShowInputNewTimesModal(true)
    }

    useEffect(() => {
        fetchCandidateDVTJCUV(candidateId);
    }, [candidateId])


    const onChangeInput = (values, column) => {
        currentUseTimes[column.key] = values
        setCurrentUseTimes({...currentUseTimes})
        // if (onChangeInputItem) {
        //     onChangeInputItem(values, column)
        // }
    }

    const onCloseInputNewTimesModal = async (reload) => {
        setShowInputNewTimesModal(false)
        await fetchCandidateDVTJCUV(candidateId)
    }

    const onCloseInputNewExpiryTimeModal = async (reload) => {
        setShowInputNewExpiryTimesModal(false)
        await fetchCandidateDVTJCUV(candidateId)
    }


    const disableColumn = (column) => {
        if (!column.editable || !isEdit) {
            return true
        }

        if (column.key === 'service_status') {
            if (originUseTimes.service_status === ServiceStatuses.EXPIRED.id) {
                return true
            }
        }

        // if (column.key === 'first_active_date_time') {
        //     return !canEditActiveTime;
        // }

        return false
    }

    const displayStatusFieldValues = (field) => {
        if (field.key === 'dvtjcuv_find_job_mode') {
            // find value in JobFindModeOptions
            return JobFindModeOptions.find(item => item.value.toString() === currentUseTimes[field.key].toString())
        }

        return currentUseTimes[field.key]
    }

    return (
        <>
            {currentUseTimes.id &&
                <div className='card card-default'>
                    {mode !== 'Search' &&
                    <div className='card-header'>
                        <div className='card-title text-bold mb-3 w-100'> Cdd ID (DVTJCUV): {firstClient.id}</div>
                        <h3 className='card-title text-bold'>Lần SDDV gần nhất</h3>
                        <div className='card-tools'>
                            {!isEdit &&
                                <button type='button'
                                        className='btn btn-info mr-2'
                                        onClick={() => {
                                            setShowInputNewExpiryTimesModal(true);
                                        }}
                                >
                                    Gia hạn
                                </button>
                            }
                            {isEdit &&
                                <>
                                    <button type='button'
                                            className='btn btn-default ml-2 mr-2'
                                            onClick={() => {
                                                setIsEdit(false);
                                            }}
                                    >
                                        Cancel
                                    </button>

                                    <button type='button'
                                            className='btn btn-primary'
                                            onClick={() => {
                                                updateCandidateDVTJCUV();
                                            }}
                                    >
                                        Save
                                    </button>
                                </>
                            }
                            {!isEdit && originUseTimes.service_status !== ServiceStatuses.EXPIRED.id &&
                                <button type='button'
                                        className='btn btn-default'
                                        onClick={() => {
                                            setIsEdit(true);
                                        }}
                                >
                                    Edit
                                </button>
                            }
                        </div>
                    </div>
                    }
                    {mode !== 'Search' &&
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>DVTJCUV</h3>
                        </div>
                    }
                    <div className='card-body'>
                        <div className={'row'}>
                            {DVTJCUVUseStatusFields.map((column) => {
                                if (column.inputType === 'option') {
                                    const columnOptions = column.key === 'service_status' ? statusOptions : column.options
                                    return <div className='col-sm-6' key={`CandidateDVTJCUV_input_item_${column.key}`}>
                                        <div className='form-group'>
                                            <div style={{width: '100%'}}>
                                                <label className={`w-100}`}>{column.label}</label>
                                                <Select options={columnOptions}
                                                        value={displayStatusFieldValues(column)}
                                                        isDisabled={disableColumn(column)}
                                                        name={column.key}
                                                        isMulti={!!column.isMulti}
                                                        onChange={value => {
                                                            onChangeInput(value, column);
                                                        }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                                return <div className='col-sm-6' key={`CandidateDVTJCUV_input_item_${column.key}`}>
                                    <div className='form-group'>
                                        <label className={'w-100'}>{column.label}</label>
                                        <input type={column.inputType} className='form-control'
                                               disabled={disableColumn(column)}
                                               value={currentUseTimes[column.key]}
                                               name={column.key}
                                               onChange={event => onChangeInput(event.target.value, column)}/>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            }
            {mode !== 'Search' &&
            <div className='card card-default'>
                <div className='card-header'>
                    <div className='card-title text-bold'>Các lần SD DV</div>
                    <div className={'card-tools'}>
                        <button type='button'
                                className='btn btn-primary btn-sm'
                                onClick={() => {
                                    onCreateNewUseTimes();
                                }}
                        >
                            Nhập Lần SDDV mới
                        </button>
                    </div>
                </div>
                <div className='card-body table-responsive p-0'>
                    <table
                        className='table table-hover table-bordered text-nowrap'
                    >
                        <thead>
                        <tr>
                            <th>STT</th>
                            {DVTJCUVClientFields.map((column) => {
                                return <th>{column.label}</th>
                            })}
                        </tr>
                        </thead>
                        <tbody>
                        {useTimesList.map((item, index) => (
                            <tr key={`CandidateDVTJCUV_DVTJCUV_Client_${index}`}>
                                <td>{index + 1}</td>
                                {DVTJCUVClientFields.map((column) => {
                                    return <td>{item[column.key]}</td>
                                })}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            }
            {mode !== 'Search' &&
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>History Trạng thái SD DV</h3>
                </div>
                <div className='card-body table-responsive p-0'>
                    <table
                        className='table table-hover table-bordered text-nowrap'
                    >
                        <thead>
                        <tr>
                            <th>STT</th>
                            <th>Lần SD DV</th>
                            <th>Trạng thái SD DV</th>
                            <th>Note Time</th>
                        </tr>
                        </thead>
                        <tbody>
                        {serviceStatusHistories && serviceStatusHistories.length > 0 && serviceStatusHistories.map((item, index) => (
                            <tr key={`CandidateDVTJCUV_DVTJCUV_Client_history_${index}`}>
                                <td>{index + 1}</td>
                                <td>{item.service_use_times}</td>
                                <td>{getSelectedStatusOption(item.service_status)?.label}</td>
                                <td>{item.created_date_time}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            }
            {showInputNewTimesModal &&
                <CandidateDVTJCUVInputNewTimesModal isShow={showInputNewTimesModal}
                                                    candidateId={candidateId}
                                                    currDVTJCUV={currentUseTimes}
                                                    onClose={(reload) => onCloseInputNewTimesModal(reload)}/>
            }
            {showInputNewExpiryTimesModal &&
                <CandidateDVTJCUVExtendExpiryTimeModal isShow={showInputNewExpiryTimesModal}
                                                    dvtjcuv={currentUseTimes}
                                                    onClose={(reload) => onCloseInputNewExpiryTimeModal(reload)}/>
            }
        </>
    )
}

export default CandidateDVTJCUV;
